import React, { Fragment } from 'react';
import FormProduto from '../../../components/produto/form-produto';
import NavBar from '../../../components/layout/navbar/index';

export default function Pessoa(props) {
    const produtoTemp = props.location.state.registroUnico;
    return (
        <Fragment>
            <NavBar />
            <FormProduto produto={produtoTemp} />
        </Fragment>
    )
}